exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1bUCHr1OTrjtdzE0AUoAfm{-ms-user-select:none;-khtml-user-select:none;-moz-user-select:none;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;margin-top:-10px;width:50%;margin:0 auto}._3rtdsX_-k2HS2RIyMkPOjr{display:inline-block;width:45px;height:45px;font-size:17px;line-height:45px;border:1px solid #322d63;border-radius:5px;margin-right:5px;margin-bottom:5px;cursor:pointer;background-color:#eee;color:#322d63;font-family:jelly_crazies}._3rtdsX_-k2HS2RIyMkPOjr._2HylArx7BP1A86ZJMiz_Dp{background-color:#b3d334}._3rtdsX_-k2HS2RIyMkPOjr._3LOteQv5KaOdLPSnlusHlZ{background-color:#ff4500}._3rtdsX_-k2HS2RIyMkPOjr._2MNLgwiDnR6IMkPNjeHF2j{background-color:#e2a562}@media screen and (max-width:1080px){._3rtdsX_-k2HS2RIyMkPOjr{width:40px;height:40px;line-height:40px;font-size:16px}}@media screen and (max-width:900px){._1bUCHr1OTrjtdzE0AUoAfm{width:100%}}@media screen and (max-width:680px){._3rtdsX_-k2HS2RIyMkPOjr{width:30px;height:30px;line-height:30px;font-size:14px}}", ""]);

// exports
exports.locals = {
	"box": "_1bUCHr1OTrjtdzE0AUoAfm",
	"letter": "_3rtdsX_-k2HS2RIyMkPOjr",
	"good": "_2HylArx7BP1A86ZJMiz_Dp",
	"bad": "_3LOteQv5KaOdLPSnlusHlZ",
	"maybe": "_2MNLgwiDnR6IMkPNjeHF2j"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Alphabet/Alphabet.scss
 ** module id = 334
 ** module chunks = 0
 **/